import { StrictMode } from 'react'
import './i18n'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'

/**
 * Detect the browser's native scrollbar width and expose it as a CSS custom
 * property (--scrollbar-width) on :root.  This lets any component offset
 * right-edge elements by exactly the right amount so they're never hidden
 * behind the scrollbar gutter.
 *
 * The measurement is done with a temporary off-screen div so it has zero
 * visual impact and runs synchronously before the first paint.
 */
function detectScrollbarWidth() {
  const el = document.createElement('div');
  el.style.cssText = 'position:fixed;top:-9999px;width:100px;height:100px;overflow:scroll;visibility:hidden;pointer-events:none;';
  document.body.appendChild(el);
  const width = el.offsetWidth - el.clientWidth;
  document.body.removeChild(el);
  document.documentElement.style.setProperty('--scrollbar-width', `${width}px`);
}

detectScrollbarWidth();
// Re-measure on resize (e.g. when OS zoom level changes)
window.addEventListener('resize', detectScrollbarWidth, { passive: true });

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
